import React from "react";
import { IRoute } from "./interfaces/route.interface";

const PropertiesPage = React.lazy(() =>  import("../pages/PropertiesPage"));
const EditPropertiesPage = React.lazy(() => import("../pages/EditPropertiesPage"));

export const propertiesRoutes:IRoute[] = [
    {
        path: "/properties",
        exact: true,
        component: PropertiesPage,
        privateRoute: true,
    },
    {
        path: "/properties/:propertyId",
        exact: true,
        component: EditPropertiesPage,
        privateRoute: true,
    }
];